var map = {
	"./category/_id.vue": [
		"c026",
		"chunk-26394818",
		"chunk-717ced4e"
	],
	"./game/_id.vue": [
		"b02a",
		"chunk-26394818",
		"chunk-3542445d"
	],
	"./index/index.vue": [
		"37f9",
		"chunk-50fa1352"
	],
	"./layouts/main.vue": [
		"5658",
		"chunk-6d7743ab"
	],
	"./pages/about.vue": [
		"ff3c",
		"chunk-563d45e0"
	],
	"./pages/contact.vue": [
		"c444",
		"chunk-d80cafc0"
	],
	"./pages/privacy.vue": [
		"6b32",
		"chunk-7fa2046c"
	],
	"./pages/terms.vue": [
		"689d",
		"chunk-242503ff"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;